import React, { useEffect, useState } from 'react';
import { Carousel } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ModijiBannerEnglish from '../../assets/banner.jpg';
import ModijiBannerHindi from '../../assets/banner.jpg';
// The landing banner. Its counterpart shs-2026-banner-updated.jpeg is the
// sidebar logo and the login-page artwork -- both were moved to the -updated
// files at the same time (2026-09-15), so the two are kept in step.
import ShsBanner from '../../assets/shs-2026-digital-banner-updated.jpeg';

export default function LandingCarousel() {
  const { i18n } = useTranslation();
  const [banners, setBanners] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  // Determine banners based on language
  const getBanners = () => {
    if (i18n.language === 'en') {
      setBanners([ShsBanner]);
    } else if (i18n.language === 'hi') {
      setBanners([ShsBanner]);
    }
  };

  useEffect(() => {
    getBanners();
    setCurrentIndex(0);
  }, [i18n.language]);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % banners.length);
    }, 7000);

    return () => clearInterval(timer);
  }, [banners]);

  // The parent on the landing page is a centred flex column, so the carousel
  // would shrink to fit its image. An explicit width makes it span the page.
  return (
    <Carousel activeIndex={currentIndex} onSelect={() => {}} style={{ width: '100%' }}>
      {banners.map((banner, index) => (
        <Carousel.Item key={index}>
          <img
            src={banner}
            alt={`banner-${index}`}
            style={{
              width: '100%',
              height: 'auto',
              display: 'block',
            }}
          />
        </Carousel.Item>
      ))}
    </Carousel>
  );
}
